/*
         * @ngdoc function
         * @name ePay.Model:Session_EPayOptionsModel
         * @description
         * Model
         */

export class Session_EPayOptionsModel {
  css: string | null | undefined;
  payThroughToDate: Date | null | undefined;
  payThroughFromDate: Date | null | undefined;
  quickInsert: boolean | null | undefined;
  updatePage: boolean | null | undefined;
  postQuestionare: boolean | null | undefined;
  preQuestionare: string | null | undefined;
  shoppingCartPage: boolean | null | undefined;
  searchPage: boolean | null | undefined;
  showBilling: boolean | null | undefined;
  profile: string | null | undefined;

  constructor(
    css?: string,
    payThroughToDate?: Date,
    payThroughFromDate?: Date,
    quickInsert?: boolean,
    updatePage?: boolean,
    postQuestionare?: boolean,
    preQuestionare?: string,
    shoppingCartPage?: boolean,
    searchPage?: boolean,
    showBilling?: boolean,
    profile?: string
  ) {
    this.css = css || null;
    this.payThroughToDate = payThroughToDate || null;
    this.payThroughFromDate = payThroughFromDate || null;
    this.quickInsert = quickInsert || null;
    this.updatePage = updatePage || null;
    this.postQuestionare = postQuestionare || null;
    this.preQuestionare = preQuestionare || null;
    this.shoppingCartPage = shoppingCartPage || null;
    this.searchPage = searchPage || null;
    this.showBilling = showBilling || null;
    this.profile = profile || null;
  }
}
